import baseCategories from './categories.json';

export default baseCategories;
